import { createContext, useEffect, useReducer } from "react";

const reducer = (state, action) => {
  switch (action.type) {
    case "LOAD_NOTIFICATIONS": {
      return { ...state, notifications: Array.isArray(action.payload) ? action.payload : [] };
    }

    case "DELETE_NOTIFICATION": {
      return { ...state, notifications: Array.isArray(action.payload) ? action.payload : [] };
    }

    case "CLEAR_NOTIFICATIONS": {
      return { ...state, notifications: [] };
    }

    default:
      return state;
  }
};

const NotificationContext = createContext({
  notifications: [],
  deleteNotification: () => {},
  clearNotifications: () => {},
  getNotifications: () => {},
  createNotification: () => {}
});

export const NotificationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, { notifications: [] });

  const deleteNotification = async (notificationID) => {
    try {
      const current = Array.isArray(state?.notifications) ? state.notifications : [];
      const updated = current.filter((item) => item?.id !== notificationID);
      dispatch({ type: "DELETE_NOTIFICATION", payload: updated });
    } catch (e) {
      console.error(e);
    }
  };

  const clearNotifications = async () => {
    try {
      dispatch({ type: "CLEAR_NOTIFICATIONS" });
    } catch (e) {
      console.error(e);
    }
  };

  const getNotifications = async () => {
    // No backend endpoint for /api/notification exists in production.
    // Default to empty array to prevent SPA index.html responses from polluting state.
    dispatch({ type: "LOAD_NOTIFICATIONS", payload: [] });
  };

  const createNotification = async (notification) => {
    try {
      const current = Array.isArray(state?.notifications) ? state.notifications : [];
      dispatch({ type: "LOAD_NOTIFICATIONS", payload: [...current, notification] });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        getNotifications,
        deleteNotification,
        clearNotifications,
        createNotification,
        notifications: Array.isArray(state?.notifications) ? state.notifications : []
      }}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;

